import { z } from 'zod'

export * from './types'

export const freeagentSettingsSchema = z.object({
  api: z.string().url(),
})
